import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router";
import { Grid } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useEffect } from "react";
import Loader from "../elements/Loader";
import { useState } from "react";
import { Footer } from "../elements/Footer";

const image = "/2.png";
const dashboardImg = "/background.jpg";
const logo = "/gainss-logo.png";

function LandingPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tokenData = JSON.parse(atob(token.split(".")[1]));
      const isTokenValid = Date.now() <= tokenData.exp * 1000;
      if (isTokenValid) {
        navigate("/dashboard", { replace: true });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            backgroundImage: `url(${dashboardImg})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box sx={{ p: 3 }}>
            <Grid container spacing={2}>
              <Grid
                item
                md={6}
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <img src={logo} width="60%" alt="GAINSS" />
                  </Box>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "#3f3f49",
                    }}
                  >
                    GAINSS is your comprehensive solution for efficient test
                    case management. Whether you're tracking test execution,
                    managing automated scripts, or collaborating with your team,
                    GAINSS makes it simple and intuitive.
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: "center",
                      fontSize: "16px",
                      mt: 3,
                      fontWeight: 500,
                      color: "#3f3f49",
                    }}
                  >
                    Sign up today to experience hassle-free test management and
                    boost your productivity!
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 3,
                      p: 2,
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    endIcon={<ArrowForward />}
                    onClick={() => navigate("/register")}
                  >
                    Get Started
                  </Button>
                </Box>
              </Grid>
              <Grid item md={6}>
                <img src={image} alt="GAINSS" width={"100%"} />
              </Grid>
            </Grid>
          </Box>
          <Footer />
        </Box>
      )}
    </>
  );
}

export default LandingPage;
